import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseService } from './base.service';
import { BaseCrudService } from './base-crud.service';
import { FazendaFuncionarioModel } from '../models/fazenda-funcionario.model';
import { FazendaFuncionarioParametrosModel } from '../models/fazenda-funcionario.parametros.model';

@Injectable({
  providedIn: 'root',
})
export class FazendaFuncionarioService extends BaseCrudService<FazendaFuncionarioModel, FazendaFuncionarioParametrosModel> {
  protected readonly endpoint = 'FazendaFuncionario';

  constructor(http: HttpClient) {
    super(http);
  }

  buscarFazendaFuncionario(
    parametros: FazendaFuncionarioParametrosModel
  ): Observable<ResponseService<FazendaFuncionarioModel[]>> {
    return this.buscar(parametros);
  }
}
